<template>
  <section class="container">
    <div class="row">
      <div class="col">
        <div>
          <img class="login-register-img" src="../assets/login-register.jpg"/>
        </div>
      </div>
      <div class="col">
        <div id="login-page">
          <div @click="goToHome()" class="icon-shop">
            <span class="icon-text">Back to shop</span>
            <b-icon icon="arrow-up-right-square-fill" />
          </div>
          <h2 class="form-title">Register</h2>
          <form @submit.prevent="register()" id="form-login">
            <div class="form-group">
              <input class="form-control" type="text" v-model="name" placeholder="Name">
            </div>
            <div class="form-group">
              <input class="form-control" type="email" v-model="email" placeholder="Email">
            </div>
            <div class="form-group">
              <input class="form-control" type="password" v-model="password" placeholder="Password">
            </div>
            <div class="form-group">
              <input class="form-control" type="password" v-model="password_repeat" placeholder="Repeat Password">
            </div>
            <div class="form-group">
              <button class="btn btn-warning" type="submit">Register</button>
              <p>Already have account? <a @click.prevent="goToLogin()" class="a-login" href="#">Login</a></p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      name: '',
      email: '',
      password: '',
      password_repeat: ''
    }
  },
  methods: {
    goToLogin () {
      this.$router.push('/login')
    },
    goToHome () {
      this.$router.push('/')
    },
    register () {
      if (this.password !== this.password_repeat) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: "Password didn't match!"
        })
      } else {
        const newUser = {
          name: this.name,
          email: this.email,
          password: this.password
        }
        this.$store.dispatch('register', newUser)
        this.name = ''
        this.email = ''
        this.password = ''
        this.password_repeat = ''
      }
    }
  }
}
</script>

<style scoped>
  .form-group {
    margin: 7px 0;
  }
  .form-title {
    margin-bottom: 15px;
  }
  .a-login {
    color: #cb952a;
    font-weight: bold;
  }
  .btn {
    width: 100%;
    margin-top: 15px;
    margin-bottom: 5px;
  }
  .container {
    background: #e2e2e2;
    margin-top: 80px;
    padding: 0;
  }
  .icon-shop {
    position: absolute;
    top: 0px;
    right: 20px;
    font-size: 30px;
  }
  .icon-shop:hover {
    color: navy;
    cursor: pointer;
  }
  .icon-shop:active {
    color: #263e4f;
  }
  .icon-text {
    padding: 7px;
    font-size: 15px;
  }
  .login-register-img {
    width: 100%
  }
  a {
    text-shadow: 0 0 10px 10px black;
  }
  #login-page {
    margin: auto;
    margin-top: 50px;
    width: 60%
  }
</style>
